module.exports = __webpack_public_path__ + "static/media/credit-card-inactive.d109b8ac.svg";